// src/components/auth/AuthModalHost.tsx
//
// Global single-instance host for the auth modal. Mounted once at
// App.tsx level so the modal survives parent unmounts (avatar menu
// closing, drawer dismissing, route changes during a flow).
//
// Why this exists: when Google sign-in opens its OAuth popup, focus
// leaves the parent window. That focus loss closes any MUI Menu /
// Popover that was open at the moment, including the avatar
// dropdown that hosts the "Login" entry point. With per-component
// AuthModal instances, the modal would unmount along with its
// containing menu — and any deferred flow (pendingGoogleLink,
// pendingGoogleConsent) would have nowhere to render its next
// step. Hosting the modal globally fixes that.
//
// Components throughout the app open this modal by calling
// `useAuthStore().openAuthModal('login' | 'signup')`. Closing is
// handled by the modal itself via closeAuthModal.

import React from "react";
import { AuthModal } from "./AuthModal";
import { useAuthStore } from "../../stores/authStore";

export const AuthModalHost: React.FC = () => {
  const authModal = useAuthStore((s) => s.authModal);
  const closeAuthModal = useAuthStore((s) => s.closeAuthModal);

  return (
    <AuthModal
      open={authModal.open}
      onClose={closeAuthModal}
      initialTab={authModal.initialTab}
    />
  );
};
